module.exports = __webpack_public_path__ + "img/20.b22bc7bc.jpg";